/**
 * @generated SignedSource<<ad76de4800e0ad0467c3d33566e163ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type shoppingCartSuccess_Query$variables = {
  orderId: string;
  skip: boolean;
};
export type shoppingCartSuccess_Query$data = {
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly user: {
          readonly email: string;
        };
      } | null;
    };
  };
  readonly node?: {
    readonly " $fragmentSpreads": FragmentRefs<"shoppingCartSuccess_OrderFragment">;
  } | null;
};
export type shoppingCartSuccess_Query = {
  response: shoppingCartSuccess_Query$data;
  variables: shoppingCartSuccess_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orderId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ContractPartner",
    "kind": "LinkedField",
    "name": "contractPartner",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ContractPartnerData",
        "kind": "LinkedField",
        "name": "data",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkToAGB",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "shoppingCartSuccess_Query",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "shoppingCartSuccess_OrderFragment"
                  }
                ],
                "type": "Order",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "shoppingCartSuccess_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Cart",
                    "kind": "LinkedField",
                    "name": "cart",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "itemType",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "amount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LicenseDefinition",
                                            "kind": "LinkedField",
                                            "name": "licenseDefinition",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "LicenseDefinitionRootInfo",
                                                        "kind": "LinkedField",
                                                        "name": "rootInfo",
                                                        "plural": false,
                                                        "selections": (v5/*: any*/),
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "TreeLicenseDefinitionData",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "LicenseDefinitionCoachingInfo",
                                                        "kind": "LinkedField",
                                                        "name": "coachingInfo",
                                                        "plural": false,
                                                        "selections": (v5/*: any*/),
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "CoachingLicenseDefinitionData",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v3/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "LicenseProductData",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CartProduct",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CartTotals",
                        "kind": "LinkedField",
                        "name": "totals",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Price",
                            "kind": "LinkedField",
                            "name": "includingAllDiscounts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "netPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "grossPrice",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "selectedPaymentMethod",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "selectedPaymentMethodType",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MonthlyOption",
                            "kind": "LinkedField",
                            "name": "chosenOption",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rateCount",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MonthlySelectedPaymentMethod",
                        "abstractKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paymentMethodId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "billingDetails",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customerType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Purchaser",
                    "kind": "LinkedField",
                    "name": "purchaser",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Order",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e4f4dbda2376f1e6be3fe6c9cf46c11f",
    "id": null,
    "metadata": {},
    "name": "shoppingCartSuccess_Query",
    "operationKind": "query",
    "text": "query shoppingCartSuccess_Query(\n  $orderId: ID!\n  $skip: Boolean!\n) {\n  node(id: $orderId) @skip(if: $skip) {\n    __typename\n    ... on Order {\n      ...shoppingCartSuccess_OrderFragment\n    }\n    id\n  }\n  Viewer {\n    Auth {\n      currentUser {\n        user {\n          email\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment basketTimeline_OrderFragment on Order {\n  id\n  cart {\n    totals {\n      includingAllDiscounts {\n        grossPrice\n      }\n    }\n  }\n  billingDetails {\n    __typename\n    customerType\n  }\n  selectedPaymentMethod {\n    __typename\n    selectedPaymentMethodType\n    ... on MonthlySelectedPaymentMethod {\n      chosenOption {\n        rateCount\n      }\n    }\n  }\n}\n\nfragment paypalButton_OrderFragment on Order {\n  id\n  cart {\n    totals {\n      includingAllDiscounts {\n        grossPrice\n      }\n    }\n  }\n  purchaser {\n    userId\n  }\n}\n\nfragment shoppingCartLegalForm_OrderFragment on Order {\n  cart {\n    items {\n      __typename\n      ... on CartProduct {\n        product {\n          data {\n            __typename\n            ... on LicenseProductData {\n              licenseDefinition {\n                data {\n                  __typename\n                  ... on TreeLicenseDefinitionData {\n                    rootInfo {\n                      contractPartner {\n                        id\n                        data {\n                          name\n                          linkToAGB\n                        }\n                      }\n                    }\n                  }\n                  ... on CoachingLicenseDefinitionData {\n                    coachingInfo {\n                      contractPartner {\n                        id\n                        data {\n                          name\n                          linkToAGB\n                        }\n                      }\n                    }\n                  }\n                }\n                id\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n  selectedPaymentMethod {\n    __typename\n    selectedPaymentMethodType\n  }\n}\n\nfragment shoppingCartSuccess_OrderFragment on Order {\n  id\n  cart {\n    items {\n      __typename\n      itemType\n      ... on CartProduct {\n        amount\n        product {\n          id\n          title\n        }\n      }\n    }\n    totals {\n      includingAllDiscounts {\n        netPrice\n      }\n    }\n  }\n  ...shoppingCartLegalForm_OrderFragment\n  ...shoppingCartTemplate_OrderFragment\n}\n\nfragment shoppingCartTemplate_OrderFragment on Order {\n  ...basketTimeline_OrderFragment\n  selectedPaymentMethod {\n    __typename\n    paymentMethodId\n  }\n  ...paypalButton_OrderFragment\n}\n"
  }
};
})();

(node as any).hash = "a48c87f7a2cb829e23688f96942fbcaf";

export default node;
